import { css } from 'emotion';
import { colors } from '@joykit/variables';

export namespace styles {
  export const container = (centered?: boolean) =>
    css({
      overflow: 'hidden',
      position: 'relative',
      margin: '0px',
      minHeight: '55px',
      padding: '20px',
      backgroundColor: colors.light,
      color: '#333',
      display: 'flex',
      justifyContent: centered ? 'center' : undefined,
      alignItems: 'center',
      fontSize: '18px',
      letterSpacing: '.3px'
    });

  export const h3 = css({});

  export const exitButton = css({
    width: '15px',
    height: '15px',
    top: '-1.5em',
    right: '-1.5em',
    cursor: 'pointer',
    position: 'absolute',
    ' svg': {
      width: '100%',
      height: 'auto',
      ' path': {
        fill: 'white'
      }
    }
  });
}
